export default __webpack_public_path__ + "static/media/loading.2507bc17.gif";